//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import PurchaseSaleBook from '@/views/purchaseSaleBook/ListPurchaseSaleBook'

//
export default {
    path: 'purchase_sale_book',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'purchase-sale-book-list',
            component: PurchaseSaleBook,
        },
    ],
    meta: {
        group: 'Contabilidad',
        title: 'Libro de compra y venta',
    },
}
